/*
 * @Author: lijing 
 * @Date: 2022-08-28 17:39:18 
 * @Last Modified by: lijing
 * @Last Modified time: 2022-09-08 16:07:06
 */
import React, { FC, useEffect, useState } from "react";
import { Modal, Tabs, Alert } from 'antd';
import { coursePreview } from '@root/common/service';
import { setVideoInfo } from "@root/reducers/video";
import VideoPlayer from "@root/components/video/index";
import { useSelector, useDispatch } from "react-redux";
const { TabPane } = Tabs;

interface IProp {
    previewId: number,
    setIsCoursePreviewVisible: React.Dispatch<React.SetStateAction<boolean>>
}

export const CoursePreview: FC<IProp> = (props) => {
    const dispatch = useDispatch();

    const { siteid } = useSelector(
        (state: any) => state.videoInfo
    );

    const [menuList, setMenuList] = useState([]);
    const [description, setDescription] = useState('');
    const [active, setActive] = useState(0);

    useEffect(() => {
        coursePreview(props.previewId).then(res => {
            setMenuList(res.data.courseSectionList);
            setDescription(res.data.content);

            changeVideo(res.data.courseSectionList[0].thirdVideoId)
        })
    }, [])

    const changeVideo = (vid: string) => {
        dispatch(
            setVideoInfo({
              vid: vid,
              siteid: siteid,
              needRecord: false,
            })
        );
    }

    return (
        <Modal
            title="课程预览"
            width={980}
            visible={true}
            footer={false}
            onCancel={() => { props.setIsCoursePreviewVisible(false) }}
        >
            <div className="coursepreview">
                <div className="coursepreview-video">
                    <VideoPlayer />
                </div>
                <div className="coursepreview-main">
                    <Tabs defaultActiveKey="1">
                        <TabPane tab="课程目录" key="1">
                            <div className="coursepreview-menu">
                                {
                                    menuList.map((item: any, index: number) => {
                                        return (
                                            <Alert 
                                                message={item.name}
                                                className={`coursepreview-menu-item ${active===index ? "coursepreview-menu-active" : ''}`}
                                                onClick={() => {
                                                    setActive(index)
                                                    changeVideo(item.thirdVideoId)
                                                }}
                                            />
                                        )
                                    })
                                }
                            </div>
                        </TabPane>
                        <TabPane tab="课程详情" key="2">
                            <div className="coursepreview-description" 
                                dangerouslySetInnerHTML={{__html: description}}
                            ></div>
                        </TabPane>
                    </Tabs>
                </div>
            </div>
        </Modal>
    );
};